import React from 'react';

import { useParams } from 'react-router-dom';

import { PhoneAnalytics } from './PhoneAnalytics';

/**
 * Standalone wrapper for PhoneAnalytics component.
 * Used when opening PhoneAnalytics in a separate window without the main app layout.
 * All necessary providers (Redux, QueryClient) are already available from the parent tree.
 */
export const PhoneAnalyticsStandalone: React.FC = () => {
  const { accountId } = useParams();

  if (!accountId) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">No se proporcionó un ID de cuenta</p>
      </div>
    );
  }

  return (
    <div className="w-full h-screen overflow-auto">
      <PhoneAnalytics accountId={Number(accountId)} isStandalone />
    </div>
  );
};
